import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { inventoryApi, type InventoryDashboard } from '../../api/inventory';

const NAV = [
  { to: '/inventory/warehouses', label: 'Warehouse dashboard' },
  { to: '/inventory/warehouse-manager', label: 'Warehouse manager' },
  { to: '/inventory/stock', label: 'Inventory dashboard' },
  { to: '/inventory/ledger', label: 'Stock ledger' },
  { to: '/inventory/transfers', label: 'Stock transfer' },
  { to: '/inventory/reservations', label: 'Reservations' },
  { to: '/inventory/allocations', label: 'Allocations' },
  { to: '/inventory/cycle-counts', label: 'Cycle count' },
  { to: '/inventory/physical-verification', label: 'Physical verification' },
  { to: '/inventory/forecast', label: 'Demand forecast' },
  { to: '/inventory/health', label: 'Inventory health' },
  { to: '/inventory/marketplace', label: 'Marketplace inventory' },
];

export function InventoryHubPage() {
  const [dashboard, setDashboard] = useState<InventoryDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void inventoryApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  const stats = dashboard
    ? [
        { label: 'Warehouses', value: dashboard.total_warehouses },
        { label: 'SKUs', value: dashboard.total_skus },
        { label: 'On hand', value: dashboard.total_on_hand },
        { label: 'Reserved', value: dashboard.total_reserved },
        { label: 'Active transfers', value: dashboard.active_transfers },
        { label: 'Pending reservations', value: dashboard.pending_reservations },
        { label: 'Health score', value: dashboard.health_score },
      ]
    : [];

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Inventory Management</h1>
      <p className="mt-1 text-sm text-slate-600">Warehouses, stock balances, reservations, transfers, and AI forecasting.</p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">
        {NAV.map((l) => (
          <Link key={l.to} to={l.to} className="text-slate-700 hover:underline">{l.label}</Link>
        ))}
      </nav>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl border bg-white p-4">
            <p className="text-sm text-slate-500">{s.label}</p>
            <p className="mt-1 text-2xl font-semibold">{String(s.value)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
